import type { FilterState } from './types';

export const initialState: FilterState = {
	filterQuery: null,
	isNewFilterQueryPending: false,
	isCurrentDataFiltered: false,
	isFilterFocused: false,
};
